/*
  PARCHE NEW ERA (velocidad, 04/11) — recomendaciones del cajon del carrito, diferidas.

  Antes se calculaban en el servidor en cada pagina con carrito (los embudos de Daniel,
  ~52 KB de HTML), aunque nadie abriera el cajon. Ahora cart-drawer.liquid deja un
  esqueleto y este elemento pide sections/cart-recommendations-diferidas:
    - en segundo plano, unos segundos despues de cargar la pagina, o
    - al abrir el cajon, si todavia no habian llegado.
  Al cambiar el carrito, el tema reemplaza el contenido del bloque (data-merge) y nace un
  elemento nuevo, que vuelve a pedirlas. Mismas recomendaciones: el snippet no cambia.
*/
(() => {
  const RETRASO_MS = 3000;
  const cache = new Map();

  let paginaCargada = document.readyState === 'complete';
  if (!paginaCargada) {
    window.addEventListener('load', () => { paginaCargada = true; }, { once: true });
  }

  const enReposo = (fn) => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(fn, { timeout: 2000 });
    } else {
      setTimeout(fn, 0);
    }
  };

  class CartRecommendationsDiferidas extends HTMLElement {
    connectedCallback() {
      this.drawer = this.closest('cart-drawer');
      this.clave = (this.closest('[data-merge]') || this).dataset.mergeCache || '';
      this.alAbrir = () => this.cargar();
      if (this.drawer) {
        this.drawer.addEventListener('on:cart-drawer:before-open', this.alAbrir);
        if (this.drawer.hasAttribute('open')) {
          this.cargar();
          return;
        }
      }
      const programar = () => {
        this.temporizador = setTimeout(() => enReposo(() => this.cargar()), RETRASO_MS);
      };
      if (paginaCargada) {
        programar();
      } else {
        window.addEventListener('load', programar, { once: true });
      }
    }

    disconnectedCallback() {
      clearTimeout(this.temporizador);
      if (this.drawer) this.drawer.removeEventListener('on:cart-drawer:before-open', this.alAbrir);
    }

    cargar() {
      if (this.peticion) return this.peticion;
      clearTimeout(this.temporizador);
      if (!cache.has(this.clave)) {
        const url = `${this.dataset.url}&_c=${encodeURIComponent(this.clave)}`;
        cache.set(this.clave, fetch(url)
          .then((r) => {
            if (!r.ok) throw new Error(`HTTP ${r.status}`);
            return r.text();
          })
          .catch((e) => {
            cache.delete(this.clave);
            throw e;
          }));
      }
      this.peticion = cache.get(this.clave)
        .then((html) => this.pintar(html))
        .catch(() => this.vaciar());
      return this.peticion;
    }

    pintar(html) {
      if (!this.isConnected) return;
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const bloque = tmp.querySelector('.cart-recommendations-dan');
      if (!bloque) {
        this.vaciar();
        return;
      }
      const titulo = bloque.querySelector('.product-info-label');
      if (titulo) titulo.textContent = this.dataset.heading;
      const esquema = this.dataset.colorScheme || '1';
      bloque.querySelectorAll('.use-color-scheme--1').forEach((el) => {
        el.classList.replace('use-color-scheme--1', `use-color-scheme--${esquema}`);
      });
      this.replaceChildren(bloque);
      this.removeAttribute('aria-busy');
      this.classList.add('cart-recommendations-diferidas--lista');
      if (this.drawer && this.drawer.hasAttribute('open') && window.theme && theme.manuallyLoadImages) {
        theme.manuallyLoadImages(this);
      }
    }

    vaciar() {
      if (!this.isConnected) return;
      this.replaceChildren();
      this.removeAttribute('aria-busy');
      this.hidden = true;
    }
  }

  if (!customElements.get('cart-recommendations-diferidas')) {
    customElements.define('cart-recommendations-diferidas', CartRecommendationsDiferidas);
  }
})();
